import React from "react";
const SearchSVG = ({ color = "black", className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      {...props}
    >
      <path
        d="M13.8533 13.6464L10.1503 9.94336C10.9908 8.94341 11.4996 7.65532 11.4996 6.24979C11.4996 3.07939 8.92035 0.5 5.74979 0.5C2.57939 0.500625 0 3.07987 0 6.25027C0 9.42067 2.57923 12.0001 5.74979 12.0001C7.15535 12.0001 8.44341 11.4913 9.44336 10.6507L13.1464 14.3538C13.2439 14.4513 13.372 14.5 13.5001 14.5C13.6282 14.5 13.7563 14.4513 13.8538 14.3538C14.0494 14.1581 14.0494 13.8425 13.8538 13.6469L13.8533 13.6464ZM1.00017 6.25043C1.00017 3.63184 3.13126 1.50059 5.75001 1.50059C8.36876 1.50059 10.4998 3.63168 10.4998 6.25043C10.4998 8.86917 8.36876 11.0003 5.75001 11.0003C3.13126 11.0003 1.00017 8.86917 1.00017 6.25043Z"
        fill={color}
      />
    </svg>
  );
};

export default SearchSVG;
